import { PaintedScene } from '../PaintedScene';

export const HILL_PATH_EAST_PHASER_KEY = 'HillPathEastScene' as const;
export const HILL_PATH_EAST_MANIFEST_KEY = 's-503-hill-path-east' as const;

export class HillPathEastScene extends PaintedScene {
  constructor() {
    super(HILL_PATH_EAST_PHASER_KEY, HILL_PATH_EAST_MANIFEST_KEY);
  }
}
